import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  label: {
    fontSize: '11px',
    fontWeight: 500,
    color: 'var(--dai-color-text-dim, var(--color-neutral-400))',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
    userSelect: 'none'
  },
  select: {
    padding: '4px 8px',
    fontSize: 'var(--font-size-xs)',
    fontWeight: 500,
    color: 'var(--dai-color-text)',
    backgroundColor: 'transparent',
    border: 'var(--dai-border1)',
    borderRadius: 'var(--border-radius-md)',
    cursor: 'pointer',
    outline: 'none',
    appearance: 'auto',
    transition: 'all 150ms ease',
    '&:hover': {
      backgroundColor: 'var(--color-neutral-100)',
      borderColor: 'var(--color-neutral-400)'
    },
    '&:focus': {
      borderColor: 'var(--color-primary-400)'
    }
  }
}))

function SkillTagSelector ({ value, onChange }) {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <span className={classes.label}>Skills Version</span>
      <select
        className={classes.select}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value='live'>live</option>
        <option value='next'>next</option>
      </select>
    </div>
  )
}

SkillTagSelector.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default SkillTagSelector
